import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { DataRelease } from '@/modules/calendar/model/calendar/data-release';
import { Button } from 'react-bootstrap';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export default function DataReleaseHistoryDownload({
  events,
  selectedRelease,
}: {
  events: NewsEvent[];
  selectedRelease: DataRelease;
}) {
  const downloadCSV = () => {
    // Convert the data array into a CSV string
    const csvString = [
      ['Date', selectedRelease.series.map(value => `"${value.display.replaceAll('"', "'")}"`)], // Specify your headers here
      ...events
        .sort((a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf())
        .map(event => [
          dayjs(event.date).format('["]YYYY-MM-DD["]'),
          ...selectedRelease.series.map(
            series =>
              `"${
                event.dataSeriesEntries.find(value => `${value.dataSeriesId}` === `${series.id}`)
                  ?.actual || ''
              }"`,
          ),
        ]),
    ]
      .map(row => row.join(','))
      .join('\n');

    // Create a Blob from the CSV string
    const blob = new Blob([csvString], { type: 'text/csv' });

    // Generate a download link and initiate the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${selectedRelease.country}_${selectedRelease.title.replaceAll(/\s+/g, '_')}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Button className={'w-100'} variant={'tertiary'} onClick={downloadCSV}>
      <FontAwesomeIcon icon={faDownload} /> Download CSV
    </Button>
  );
}
